export const FULL_ROUND_TIMES = { 1: 60, 2: 45, 3: 30 };

export function debateMaxRounds(debate) {
  return debate?.max_rounds ?? 3;
}

export function roundTimeLimit(debate, roundNum = 1) {
  if (debateMaxRounds(debate) === 1) return 60;
  return FULL_ROUND_TIMES[roundNum] ?? 60;
}

export function isExpressDebate(debate) {
  return debateMaxRounds(debate) === 1;
}

export function roundLabel(debate, roundNum = 1) {
  const max = debateMaxRounds(debate);
  if (max === 1) return "Ronda única · 60s";
  return `Ronda ${roundNum} de ${max}`;
}
